import React, { Component } from 'react';
import { Home } from './Home/Home';
import { Layout } from './Map/Layout';

export class System extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
        };
        this.changePage = this.changePage.bind(this);
    }

    changePage(page) {
        this.setState({ page: page });
    }

    render() {
        return (
            <div>
                {
                    this.state.page === 1 ? <Home changePage={this.changePage}></Home> :
                        this.state.page === 2 ? <Layout changePage={this.changePage}></Layout> : null
                }
            </div>
        );
    }
}